import React, { useEffect, useState } from 'react';
// import StundenVerortung from './Stunden/StundenVerortung';
// import StundenTaetigkeiten from './Stunden/StundenTaetigkeiten';
import Verortung from './Taetigkeitsbericht/Verortung';
import Taetigkeiten from './Taetigkeitsbericht/Taetigkeiten';

function TagesTaetigkeitVerortung({tstatus,
    taetigkeitsberichtData,
    setTaetigkeitsberichtData,
    setIsChange,
    originState
}) {
    const [data, setData] = useState([]);
    useEffect(() => {
        if (taetigkeitsberichtData?.taetigkeiten !== undefined) {
            setData(taetigkeitsberichtData);
        }
    }, [taetigkeitsberichtData]);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                width: '100%',
                maxWidth:'91%',
                height: '50vh',
                justifyContent:'space-evenly',
                // backgroundColor:'red',
                // paddingLeft:50,
                // paddingRight:50,
                margin:' 0 auto',
                // background:'red'
            }}
        >
            {data.taetigkeiten?.map((d) => {
                return (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start'
                        }}
                        key={d.id}
                    >
                        <div
                            style={{
                                width: '28%',
                                height: 'auto'
                            }}
                        >
                            <Verortung
                                setIsChange={setIsChange}
                                originState={originState}
                                taetigkeitsberichtData={taetigkeitsberichtData}
                                setTaetigkeitsberichtData={setTaetigkeitsberichtData}
                                verortungData={d.verortung}
                            />
                        </div>
                        <div
                            style={{
                                width: '70%',
                                height: 'auto'
                            }}
                        >
                            <Taetigkeiten
                                tstatus={tstatus}
                                setIsChange={setIsChange}
                                originState={originState}
                                taetigkeitsberichtData={taetigkeitsberichtData}
                                setTaetigkeitsberichtData={setTaetigkeitsberichtData}
                                taetigkeitenData={[d]}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
}

export default TagesTaetigkeitVerortung;
